<template>
  <v-overlay location-strategy="connected" ref="monthSelectOverlay" v-model="visible">
    <template #activator="{ isActive, props }">
      <v-text-field placeholder="yyyy-mm" :style="{ width: width }" v-bind="props" density="compact" :variant="variant"
        :value="displayValue" color="#2655f1" rounded autocomplete="off" prepend-inner-icon="mdi-calendar"></v-text-field>
    </template>
    <v-card class="month-select" elevation="10">
      <div class="v-date-picker-controls d-flex justify-between">
        <div>{{ selectedYear }}年{{ selectedMonth }}月</div>
        <div class=" d-flex justify-between">
          <v-btn variant="text" rounded @click="showYears = true">
            {{ selectedYear }}
            <span style="font-size: 24px;" class="mdi mdi-menu-down"></span>
          </v-btn>
          <v-btn variant="text" rounded @click="showYears = false">
            {{ selectedMonth }}
            <span style="font-size: 24px;" class="mdi mdi-menu-down"></span>
          </v-btn>
        </div>
      </div>
      <div class="v-date-picker-years" v-if="showYears">
        <div class="v-date-picker-years__content">
          <v-btn v-for="year in years" :key="year" :variant="getYearVariant(year)" rounded @click="onYearClick(year)">{{
            year }}</v-btn>
        </div>

      </div>

      <div class="v-date-picker-months" v-else>
        <div class="v-date-picker-months__content">
          <v-btn v-for="month in months" :key="month" :variant="getMonthVariant(month)" rounded
            @click="onMonthClick(month)">{{ month }}</v-btn>
        </div>
      </div>
    </v-card>
  </v-overlay>
</template>


<script setup>
import { ref, computed, watch, useTemplateRef } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  variant: {
    type: String,
    default: 'outlined'
  },
  width: {
    default: '220px'
  }
})

const emit = defineEmits(['update:modelValue'])


const monthSelectOverlay = useTemplateRef('monthSelectOverlay')
const visible = ref(false)
const years = ref([])
const showYears = ref(true)
const months = ref([])

// 当前年月
const nowYear = new Date().getFullYear()
const nowMonth = new Date().getMonth() + 1


// 选择的年月
const selectedYear = ref(nowYear)
const selectedMonth = ref(nowMonth)

const displayValue = computed(() => {
  return `${selectedYear.value}-${selectedMonth.value.toString().padStart(2, '0')}`
})


watch(displayValue, (newValue) => {
  console.log('newValue', newValue);
  emit('update:modelValue', newValue)
})

watch(() => props.modelValue, (newValue) => {
  console.log('newValue', newValue);
  try {
    const { year, month } = parseMonthSelectValue(newValue)
    selectedYear.value = year
    selectedMonth.value = month
  } catch (error) {
    console.error(error);
  }
}, { immediate: true })


// 每次打开时，先选择月
watch(visible, (newVisible) => {
  if (newVisible) {
    showYears.value = false
  }
})


function parseMonthSelectValue(value) {
  // 匹配yyyy-mm格式
  //  /^(\d{4})(?:\s+)?-(?:\s+)?(\d{2})$/
  const reg = /^(?<year>\d{4})(\s+)?-(\s+)?(?<month>\d{2})$/
  const matched = value.match(reg)
  if (matched != null) {
    return {
      year: parseInt(matched.groups.year),
      month: parseInt(matched.groups.month)
    }
  } else {
    throw new Error(`月份格式错误：${value}， 必须为 [yyyy-mm] 格式`)
  }
}

function getYearVariant(year) {

  if (nowYear == year) {
    return 'outlined'
  }
  else if (selectedYear.value === year) {
    return 'tonal'
  }
  else {
    return 'text'
  }
}

function getMonthVariant(month) {
  if (nowMonth == month) {
    return 'outlined'
  } else if (selectedMonth.value === month) {
    return 'tonal'
  }
  else {
    return 'text'
  }

}

function onYearClick(year) {
  selectedYear.value = year
  showYears.value = false
}

function onMonthClick(month) {
  selectedMonth.value = month
  visible.value = false
}


function generateYearsAndMonth() {
  for (let i = 1; i <= 12; i++) {
    months.value.push(i)
  }
  for (let i = 2015; i <= 2077; i++) {
    years.value.push(i)
  }
}

generateYearsAndMonth()



</script>

<style scoped>
.month-select {
  width: 330px;
  height: 345px;
  display: flex;
  /* background: #fff; */
  flex-direction: column;
  padding: 16px;
}

:deep(.v-input__details) {
  display: none;
}

:deep(.v-overlay__scrim) {
  background: transparent !important;
  opacity: 0 !important;
}

:deep(.v-date-picker-months) {
  height: 274px;
  padding: 0 36px;
}
</style>
